import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { Page } from '../../design/page/Page';
import { AuthContext } from '../../contexts';
import { useContext, useEffect, useState } from 'react';
import { SystemConfigData, SystemConfigResource } from '../../resources';
import { useConfirmation, useRequester } from '../../hooks';
import { Searchbar, Table } from '../../design';
import LLMConfigFormModal from './LLMConfigFormModal';

const columns = [
  {
    id: 'key',
    label: 'Key',
    align: 'center' as const,
  },
  {
    id: 'value',
    label: 'Value',
    align: 'center' as const,
  },
];

export default function SystemConfigPage() {
  const { user } = useContext(AuthContext);
  const [configForEdit, setConfigForEdit] = useState<SystemConfigData>();

  const systemConfigApi = useRequester<SystemConfigResource[]>({
    onSubmit: () => SystemConfigResource.fetchMany(),
    onError: console.log,
  });

  const deleteConfirmation = useConfirmation<string>({
    onConfirm: (key) => SystemConfigResource.deleteOverride(key),
    getTitle: (key) => `Delete Override for ${key}`,
    getDescription: (key) =>
      `Are you sure you want to delete the override for ${key}? This will restore the default value.`,
  });

  useEffect(() => {
    systemConfigApi.submit();
  }, []);

  const systemConfigs = SystemConfigResource.list().map((sc) => sc.data);

  return (
    <Page>
      <Page.Header>
        <Box className="flex flex-col h-full">
          <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
            👋 Hey, {user?.data.firstName}!
          </Typography>
          <Typography variant="h1">LLM Config</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            ⚠️ Be careful with these settings. Incorrectly setting a value can
            break the app.
          </Typography>
          <Box className="flex-grow"></Box>
        </Box>
      </Page.Header>
      <Page.Content>
        <Box className="flex justify-between mt-8 mb-8">
          <Box className="flex gap-4">
            <Searchbar
              disabled
              placeholder="Search for a config"
              onChange={(qs) => { }}
            />

            {systemConfigApi.loading && (
              <Box className="flex items-center">
                <CircularProgress size={20} />
              </Box>
            )}
          </Box>
        </Box>

        <Table
          rows={systemConfigs}
          columns={columns}
          onEdit={(row) =>
            setConfigForEdit(systemConfigs.find((c) => c.key === row.key))
          }
          onDelete={(row) => deleteConfirmation.triggerFor(row.key)}
        />
      </Page.Content>
      <LLMConfigFormModal
        config={configForEdit}
        open={!!configForEdit}
        onClose={() => setConfigForEdit(undefined)}
        onSuccess={() => {
          setConfigForEdit(undefined);
          systemConfigApi.submit();
        }}
      />
    </Page>
  );
}
